const KEY = 'borradh.impersonation.returnTo';
const MOBILE_ADMINS_PATH = '/dashboard/more/admins';

export function setImpersonationReturnTo(mobile: boolean): void {
  try {
    if (mobile) window.sessionStorage.setItem(KEY, MOBILE_ADMINS_PATH);
    else window.sessionStorage.removeItem(KEY);
  } catch {
    // Storage can be blocked. The existing admin route remains the fallback.
  }
}

/** A fixed destination, never a caller-supplied URL or a browser history entry. */
export function getImpersonationReturnPath(): string {
  try {
    return window.sessionStorage.getItem(KEY) === MOBILE_ADMINS_PATH
      ? MOBILE_ADMINS_PATH
      : '/admin';
  } catch {
    return '/admin';
  }
}
